import _ from 'lodash'

export default {
  state: {
    user: typeof user === 'undefined' ? {} : user,
    page: typeof page === 'undefined' ? {} : page,
  },
  mutations: {
    setEmailNotification(state, payload) {
      state.user = {...state.user, email_notification: {...state.user.email_notification, ...payload}}
    },
    setCypher(state, payload) {
      state.cypher = payload
    },
  },
  actions: {},
  getters: {
    isAuthenticated() {
      return true
    },
  },
}
